import React from 'react';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';

const LegalPage = () => (
  <div className="min-h-screen bg-slate-50 py-16 px-4">
    <div className="max-w-2xl mx-auto">
      <div className="flex items-center gap-3 mb-8">
        <FileText className="w-7 h-7 text-blue-600" />
        <h1 className="text-2xl font-bold text-slate-900">Mentions légales</h1>
      </div>
      <div className="bg-white rounded-xl border border-slate-200 p-8 space-y-6 text-sm text-slate-600 leading-relaxed">
        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Éditeur du site</h2>
          <p>Mehdi Bouzera, entrepreneur individuel</p>
          <p>Nom commercial : LoyalPass</p>
          <p>12 rue des Renardières, 44100 Nantes</p>
          <p>SIRET : 931 555 304 00027</p>
          <p>Contact : <a href="mailto:contact@getloyalpass.fr" className="text-blue-600 underline">contact@getloyalpass.fr</a></p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Hébergement</h2>
          <p>Railway Corporation — 548 Market St, San Francisco, CA 94104, USA</p>
        </section>
        <section>
          <h2 className="text-base font-semibold text-slate-900 mb-2">Propriété intellectuelle</h2>
          <p>L'ensemble du contenu du site (textes, images, logos, code) est protégé par le droit d'auteur. Toute reproduction non autorisée est interdite.</p>
        </section>
        <p className="text-xs text-slate-400 pt-4 border-t border-slate-100">Dernière mise à jour : 2 juillet 2026</p>
      </div>
      <div className="text-center mt-6">
        <Link to="/" className="text-sm text-slate-500 hover:text-blue-600 underline">Retour à l'accueil</Link>
      </div>
    </div>
  </div>
);

export default LegalPage;
